var $window = $(window);
var breakPoint = 1024;

var resizeFlag = false;
var windowWidth = $window.width();
var windowHeight = $window.height();

//ローディング
import {loading} from "../include/module";
loading();

//ヘッダーの開閉
import {headerToggle} from "../include/module";
headerToggle();

//ページ内リンクのアニメーション
import {anchorScroll} from "../include/module";
anchorScroll();

// preload
import {preload} from "../include/module";
preload();

// resizing
import {resizing} from "../include/module";
resizing();

// アニメーション
import {animationFire} from "../include/module";
animationFire();

//タブ切り替え
const story_Tab = () => {
  const $tabNav = $('.story-Tab').find('li');
  const $st_Wrapper = $('.st-Wrapper');
  $tabNav.on('click', function(){
    $($tabNav).removeClass('current');
    // $(this).addClass('current');
    // $($st_Wrapper).toggleClass('season1');
    // $($st_Wrapper).toggleClass('season2');
    let element = this.className;
    $(this).addClass('current');
    if (element == 'season1'){
      $($st_Wrapper).addClass('season1');
      $($st_Wrapper).removeClass('season2');
      $($st_Wrapper).removeClass('season3');
    }else if(element == 'season2'){
      $($st_Wrapper).addClass('season2');
      $($st_Wrapper).removeClass('season1');
      $($st_Wrapper).removeClass('season3');
    }else if(element == 'season3'){
      $($st_Wrapper).addClass('season3');
      $($st_Wrapper).removeClass('season1');
      $($st_Wrapper).removeClass('season2');
    }
    $('.swiper-container').each(function(){
      var mySwiper = new Swiper (this, {
        // Optional parameters
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        slidesPerView: 3,
        spaceBetween: windowWidth * 0.0078125,
        direction: 'horizontal',
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          1024: {
            slidesPerView: 1,
            spaceBetween: 0
          }
        }
      })
    });
  });
};
story_Tab();

// swiper
$('.swiper-container').each(function(){
  var mySwiper = new Swiper (this, {
    // Optional parameters
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    slidesPerView: 3,
    spaceBetween: windowWidth * 0.0078125,
    direction: 'horizontal',
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      1024: {
        slidesPerView: 1,
        spaceBetween: 0
      }
    }
  })
});



// WEBPACK FOOTER //
// ./src/assets/js/story/script.js